<template>
  <div
    class="app flex-row align-items-center"
    style="
      background-image: url(login.jpg);
      background-repeat: no-repeat;
      background-size: cover;
    "
  >
  <div class="position-absolute" style="top: 20px; right: 20px; z-index: 1000">
      <el-dropdown>
        <b-nav-item class="d-md-down">
          <div class="bg-white rounded-circle border border-primary p-3 translation-circle">
            <i style="color: #007bff" v-b-modal.translate-modal
               class="nav-icon fa fa-language fa-lg d-block"></i>
          </div>
        </b-nav-item>
        <el-dropdown-menu slot="dropdown" class="dropdown-menu-right"
       >
          <TranslateModal />
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- Container -->
    <div class="container">
      <b-row class="justify-content-center">
        <div class="row col-md-8" v-if="ticket == false">
          <b-col class="col-sm-12 col-md-12 col-lg-6 fondo-izq">
            <b-form @submit.prevent="onSubmit" data-vv-scope="formulario">

              <!-- Formulario -->
              <h1>Bienvenido a</h1>
              <img src="img/brand/logo_soluquim.png" width="200" height="50" />
              <p mt-2 class="text-muted">
                El Sistema de administración de sustancias y productos químicos
              </p>
              <span class="text-danger span-error small">{{
                errors.first("formulario.email")
              }}</span>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-user"></i>
                  </b-input-group-text>
                </b-input-group-prepend>

                <b-form-input
                  v-model="ingreso.email"
                  name="email"
                  id="email"
                  type="text"
                  class="form-control"
                  placeholder="Usuario"
                  autocomplete="username email"
                  data-vv-as=" "
                  v-validate="'required|email'"
                />
              </b-input-group>
              <span class="text-danger span-error small">{{
                errors.first("formulario.password")
              }}</span>
              <b-input-group class="mb-2">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="icon-lock"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  v-model="ingreso.password"
                  name="password"
                  id="password"
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  autocomplete="current-password"
                  data-vv-as=" "
                  v-validate="'required|max:255'"
                />
                <b-input-group-append>
                  <b-button @click="mostrarContrasena"
                    ><i v-if="!visible" class="fa fa-eye-slash"></i>
                    <i v-if="visible" class="el-icon-view"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>

              <!-- Google reCAPTCHA -->
              <div class="mb-2">
                <VueRecaptcha ref="recaptcha" :sitekey="sitekey" @verify="onRecaptchaVerify"></VueRecaptcha>
              </div>

              <!-- Botones -->
              <b-row v-if="!loading">
                <b-col cols="6">
                  <b-button
                    variant="primary"
                    :disabled="loading || !recaptchaResponse"
                    type="submit"
                    class="px-4"
                    >Ingrese</b-button
                  >
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button variant="link" class="px-0">
                    <router-link to="recuperar-contrasena"
                      >¿Olvidó la Contraseña?</router-link
                    >
                  </b-button>
                </b-col>
              </b-row>
              <b-row v-else>
                <b-col cols="12" class="d-flex justify-content-center">
                  <p class="text-gray-300 text-center bg-gray-100 py-2 px-3 rounded">
                    {{ messageRecaptcha }}
                  </p>
                </b-col>
              </b-row>

            </b-form>
          </b-col>
          <b-col
            class="col-sm-12 col-md-12 col-lg-6 fondo-der"
            style="background-image: url(contactenos.jpg); background-size: auto"
          >
            <b-card-body class="text-center">
              <div>
                <b-button variant="primary" @click="cambiaTicket" class="active mt-5"
                  >Contactenos</b-button
                >
              </div>
            </b-card-body>
          </b-col>
        </div>
      </b-row>

      <div v-if="ticket == true">
        <TicketContacto />
      </div>
    </div>
  </div>
</template>

<script>

// Importaciones generales
import Vue from "vue";
import { mapState, mapActions, mapMutations } from "vuex";

// Componentee
import TicketContacto from "../tickets/TicketContacto";
import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import Swal from "sweetalert2";
import { VueRecaptcha } from 'vue-recaptcha'
import TranslateModal from "../../containers/TranslateModal.vue";

Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});
Validator.localize("es", es);

export default {
  name: "Login",
  components: {
    TicketContacto,
    Swal,
    VueRecaptcha,
    TranslateModal
  },
  data() {
    return {
      visible: false,

      // reCAPTCHA
      recaptchaResponse: null,
      sitekey: process.env.VUE_APP_KEY_SITE_GOOGLE_RECAPTCHA || null,
      messageRecaptcha: "Procesando su envío, por favor espere...",
      observer: null,
    };
  },
  created() {

    // Si el endPoint es para autenticación con Azure entonces se transforma la URl para redireccionar al mismo.
    if(location.pathname == '/azure-auth.microsoftonline.com' && 'search' in location) window.location.href = `/#${location.pathname}${location.search}`

    this.ingreso.password = "";
  },
  mounted() {
      this.observeTranslationWidget();
    },
    beforeDestroy() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },
  methods: {
    ...mapActions("autenticacion", [
      "authentication",
      "validateIsCurrentUserAHuman"
    ]),
    ...mapMutations("autenticacion", ["cambiaTicket", 'setLoading', 'reloadRECAPTCHA']),
    onSubmit() {
      this.$validator.validateAll("formulario").then(async (result) => {
        if (!result) return false;

        let showAlertReCAPTCHAFail = true;

        if (this.recaptchaResponse) {

          await this.validateIsCurrentUserAHuman({
            'g-recaptcha-response': this.recaptchaResponse
          });

          // reCAPTCHA validado por Google
          if (this.reCAPTCHA.isValid) {

            showAlertReCAPTCHAFail = false;

            this.setLoading(true);
            await this.authentication(this.$router);
            if(this.reCAPTCHA.reload){
                this.reloadRECAPTCHA(false);
                this.$refs.recaptcha.reset();
            }
            this.setLoading(false);
          }
        }

        if (showAlertReCAPTCHAFail) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Autenticación de usuarios',
            text: 'Ups, no fue posible realizar las validaciones de seguridad (Google reCAPTCHA)',
            showConfirmButton: true
          })
        }

      });
    },
    mostrarContrasena() {
      var tipo = document.getElementById("password");
      if (tipo.type == "password") {
        tipo.type = "text";
        this.visible = true;
      } else {
        tipo.type = "password";
        this.visible = false;
      }
    },

    /**
     * Verificación de la respuesta del recaPTCHA
     * @param {*} response
     * @author Fernando Claros
     */
    onRecaptchaVerify(response) {
      this.recaptchaResponse = response;
    },
    observeTranslationWidget() {
        const googleTranslateContainer = document.body;

        this.observer = new MutationObserver(() => {
          const googleTranslateDropdown = document.querySelector(".goog-te-combo");
          if (googleTranslateDropdown) {
            googleTranslateDropdown.value = "en";
            googleTranslateDropdown.dispatchEvent(new Event("change"));
            this.observer.disconnect();
          }
        });

        this.observer.observe(googleTranslateContainer, {
          childList: true,
          subtree: true,
        });
      },
  },
  computed: {
    // Estados para el modulo de Login
    ...mapState("autenticacion", [
      "ingreso",
      "status",
      "contrasena",
      "ticket",
      "columnas",
      "error",
      'reCAPTCHA',
      'loadRECAPTCHA',
      'loading'
    ]),
  },
};
</script>

<style scoped>
.text-muted {
  margin-top: 1rem;
}
.fondo-izq {
  background: #fff;
  padding: 32px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.fondo-der {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

@media screen and (max-width: 991px) {
  .fondo-izq {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    border-bottom-left-radius: 0px;
  }

  .fondo-der {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-right-radius: 0px;
  }
}

/* Updated styles for the translation circle */
.el-dropdown-menu {
  margin-top: 10px !important;
}
.border-primary {
  border-color: #007bff !important;
}
.translation-circle {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fa-language {
  font-size: 2.0rem;
  transition: transform 0.3s ease;
}
.fa-language:hover {
  transform: scale(1.1);
}

</style>
